import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { PostRequest } from "@/lib/http";
import { useNavigate } from "react-router-dom";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { code } = useParams();

  useEffect(() => {
    const verifyEmail = async () => {
      if (!code) {
        setError("Verification code is missing");
        return;
      }

      const { data, err } = await PostRequest({
        url: "/api/verify-email",
        body: { code },
        setState: setLoading,
      });

      if (err) {
        setError(err);
      } else {
        localStorage.setItem("user-token", data.token);
        navigate("/dashboard");
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="rounded-lg bg-white p-8 shadow-lg">
        <h1 className="mb-4 text-center text-2xl font-semibold">
          Email Verification
        </h1>
        {loading ? (
          <div className="text-center">
            <div className="border-primary mx-auto h-8 w-8 animate-spin rounded-full border-b-2"></div>
            <p className="text-muted-foreground mt-4">
              Verifying your email...
            </p>
          </div>
        ) : error ? (
          <div className="text-destructive text-center">{error}</div>
        ) : (
          <div className="text-muted-foreground text-center">
            Please wait while we verify your email address.
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
